export const createRequestBody = (values) => {
    let domainCode = values && values.issuerNumber && values.issuerNumber.domainCode;
    // let domainCode = values && values.issuerNumber && values.issuerNumber.issuerCode ? values.issuerNumber.domainCode : "ISW";
    if (values && values.cardPan) {
        let requestParams = {};
        const reportType = values && values.issuer ? "ISSUER" : "CARD";
        requestParams["pan"] = values.cardPan;
        requestParams["reportType"] = "CARD";
        requestParams["fromDate"] = values.startDate ? `${values.startDate.getFullYear()}-${("0" + (values.startDate.getMonth() + 1)).slice(-2)}-${("0" + values.startDate.getDate()).slice(-2)}` : "";
        requestParams["toDate"] = values.endDate ? `${values.endDate.getFullYear()}-${("0" + (values.endDate.getMonth() + 1)).slice(-2)}-${("0" + values.endDate.getDate()).slice(-2)}` : "";
        requestParams["page"] = values && values.pageNum ? values.pageNum : 1;
        requestParams["pageSize"] = values && values.pageSize ? values.pageSize : 10;

        if (values.download) {
            //check if the issuers is an admin or not.
            let fileType = values && values.fileType;
            return {
                domainCode,
                fileType,
                requestParams,
            };
        }

        return {
            domainCode,
            reportType,
            requestParams,
        };
    }
    if (values && values.issuer) {
        let requestParams = {};
        const reportType = values && values.issuer ? "ISSUER" : "CARD";

        requestParams["reportType"] = "ISSUER";
        requestParams["fromDate"] = values.startDate ? `${values.startDate.getFullYear()}-${("0" + (values.startDate.getMonth() + 1)).slice(-2)}-${("0" + values.startDate.getDate()).slice(-2)}` : "";
        requestParams["toDate"] = values.endDate ? `${values.endDate.getFullYear()}-${("0" + (values.endDate.getMonth() + 1)).slice(-2)}-${("0" + values.endDate.getDate()).slice(-2)}` : "";
        requestParams["page"] = values && values.pageNum ? values.pageNum : 1;
        requestParams["pageSize"] = values && values.pageSize ? values.pageSize : 10;

        if (values.download) {
            //check if the issuers is an admin or not.
            let fileType = values && values.fileType;
            return {
                domainCode,
                fileType,
                requestParams,
            };
        }

        return {
            domainCode,
            reportType,
            requestParams,
        };
    }
    if (values && values.cardProgram) {
        //Search card statement by programme
        const reportType = "SCHEME";
        const requestParams = {
            cardProgram: values.cardProgram.cardProgram,
            //cardProgram: "ECO SAROAGROVPP",
            reportType: "SCHEME",
            fromDate: values.startDate ? `${values.startDate.getFullYear()}-${("0" + (values.startDate.getMonth() + 1)).slice(-2)}-${("0" + values.startDate.getDate()).slice(-2)}` : "",
            toDate: values.endDate ? `${values.endDate.getFullYear()}-${("0" + (values.endDate.getMonth() + 1)).slice(-2)}-${("0" + values.endDate.getDate()).slice(-2)}` : "",
            page: values && values.pageNum ? values.pageNum : 1,
            pageSize: values && values.pageSize ? values.pageSize : 10,
        };
        if (values.download) {
            //requestParams["download"] = true;
            let fileType = values && values.fileType;

            return {
                domainCode,
                fileType,
                requestParams,
            };
        }
        return {
            domainCode,
            reportType,
            requestParams,
        };
    }
};
